import { gql } from "graphql-tag";

export const updateProgress = gql`
  mutation UpdateGoalProgress($id: Int!) {
    update_goal_progress(id: $id) {
      goal {
        ...GoalFragment
      }
    }
  }
`;
